import { render, staticRenderFns } from "./IFEModal.vue?vue&type=template&id=fcccc9fc&scoped=true"
import script from "./IFEModal.vue?vue&type=script&lang=js"
export * from "./IFEModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcccc9fc",
  null
  
)

export default component.exports